import t from "../../utils/esm/generateUtilityClasses/generateUtilityClasses.js";
import e from "../../utils/esm/generateUtilityClass/generateUtilityClass.js";
function a(o) {
  return e("MuiAutocomplete", o);
}
const l = t("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
export {
  l as default,
  a as getAutocompleteUtilityClass
};
